export default __webpack_public_path__ + "static/media/background.8dec7a4a.svg";